import { render, staticRenderFns } from "./table-body.vue?vue&type=template&id=4afb4e32&scoped=true&"
import script from "./table-body.vue?vue&type=script&lang=js&"
export * from "./table-body.vue?vue&type=script&lang=js&"
import style0 from "./table-body.vue?vue&type=style&index=0&id=4afb4e32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4afb4e32",
  null
  
)

export default component.exports